import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import Marquee from "./Marquee";
import WhatsAppButton from "./WhatsAppButton";

const Layout = () => (
    <div className="min-h-screen flex flex-col bg-white">
        <Header />
        <Marquee />
        <main className="flex-1">
            <Outlet />
        </main>
        <Footer />
        <WhatsAppButton />
    </div>
);

export default Layout;
